

import { Box, CircularProgress } from "@mui/material";
import { UseRoleContext } from "../../../utils/RoleContext";
import Dashboard from "./Dashboard/Dashboard";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";



const ProtectedLayout = () => {
  const context = UseRoleContext();
  if (!context.basicUserInfo) {
    window.location.href = "/login";
  }
  const nav = useNavigate();
  useEffect(() => {

    if (context.basicUserInfo) {
    } else {
      nav("/login")
    }
  }, [context])
  if (context.isLoading) {
    return (<Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>)
  }
  return (
    <>
      <Dashboard />
    </>
  );
};

export default ProtectedLayout;